import {
  CORE_LOAD_ORDERS_EVENT_REQUEST,
  CORE_LOAD_ORDERS_EVENT_SUCCESS,

  CORE_LOAD_ALLFACILITIES_REQUEST,
  CORE_LOAD_ALLFACILITIES_SUCCESS,

  CORE_LOAD_ALLFOODANDBEV_REQUEST,
  CORE_LOAD_ALLFOODANDBEV_SUCCESS,

  CORE_LOAD_ORDERAMENITIES_REQUEST,
  CORE_LOAD_ORDERAMENITIES_SUCCESS,

  CORE_LOAD_ORDERFOODANDBEV_REQUEST,
  CORE_LOAD_ORDERFOODANDBEV_SUCCESS,

  CORE_LOAD_ORDERINFO_REQUEST,
  CORE_LOAD_ORDERINFO_SUCCESS,

} from '../../types'

const initialState = []

export default {
  ordersRoom: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ORDERS_EVENT_REQUEST:
        return []
      case CORE_LOAD_ORDERS_EVENT_SUCCESS:
        if (action.payload)
          return action.payload
        else return []
      default:
        return state
    }
  },
  facilities: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLFACILITIES_REQUEST:
        return []
      case CORE_LOAD_ALLFACILITIES_SUCCESS:
        if (action.payload)
          return action.payload
        else return []
      default:
        return state
    }
  },
  foodAndBev: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLFOODANDBEV_REQUEST:
        return []
      case CORE_LOAD_ALLFOODANDBEV_SUCCESS:
        if (action.payload)
          return action.payload
        else return []
      default:
        return state
    }
  },
  orderFacilities: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ORDERAMENITIES_REQUEST:
        return state
      case CORE_LOAD_ORDERAMENITIES_SUCCESS:
        if (action.payload)
          return action.payload
        else return initialState
      default:
        return state
    }
  },
  orderFoodAndBev: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ORDERFOODANDBEV_REQUEST:
        return state
      case CORE_LOAD_ORDERFOODANDBEV_SUCCESS:
        if (action.payload)
          return action.payload
        else return initialState
      default:
        return state
    }
  },
  orderInfo: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_ORDERINFO_REQUEST:
        return {}
      case CORE_LOAD_ORDERINFO_SUCCESS:
        if (action.payload)
          return action.payload
        else return initialState
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/features/order/reducer.js